// 库存中心
import R3 from '@syman/burgeon-r3';
import qs from "qs";

const {network} = R3;
export default {
    inventoryModelQuery: params => network.post('/api/cs/md/inventoryModel/query', params),
    storageQuery: params => network.post('/api/cs/sg/bill/storage/query', params),
    // 出库通知单-（按查询条件重传WMS按钮
    sgPhyOutNoticesSendWMSAgainCondition: params => network.post('/p/cs/sgPhyOutNoticesSendWMSAgainCondition', params),
    // 库存同步队列表
    getChannelSynstockQuery: params => network.post('/api/cs/getChannelSynstockQuery', params),
    // 库存计算缓存池
    getChannelStorageBufferQuery: params => network.post('/api/cs/getChannelStorageBufferQuery', params),
    // 平台店铺库存变动流水
    getChannelStorageFtpQuery: params => network.post('/api/cs/getChannelStorageFtpQuery', params), // 获取列表数据
    // 配销仓明细
    objectTab: params => network.post('/p/cs/objectTab', params),

    // 店仓评分
    queryShareScoreFactor: params => network.post('/api/cs/sg/ScoreStrategy/queryShareScoreFactor', params),
    queryByPhyWarehouseId: params => network.post('/api/cs/sg/ScoreStrategy/queryByPhyWarehouseId', params),
    ScoreStrategySave: params => network.post('/api/cs/sg/ScoreStrategy/save', params),
    deleteByStoreIds: params => network.post('/api/cs/sg/ScoreStrategy/deleteByStoreIds', params),

    // 寻源策略
    sgChannelSourceStrategySave: params => network.post('/api/cs/sg/SgChannelSourceStrategy/save', params), // 寻源策略主表明细表保存
    SgChannelSourceStrategyRuleItemQuery: params => network.post('/api/cs/sg/SgChannelSourceStrategyRuleItem/query', params), // 寻源规则查询
    SgChannelSourceStrategyRuleItemNewLine: params => network.post('/api/cs/sg/SgChannelSourceStrategyRuleItem/newLine', params), // 寻源规则新增行
    SgChannelSourceStrategyForceItemDelete: params => network.post('/api/cs/sg/SgChannelSourceStrategyForceItem/delete', params), // 强制寻源规则删除
    SgChannelSourceStrategyForceItemQuery: params => network.post('/api/cs/sg/SgChannelSourceStrategyForceItem/query', params), // 强制寻源规则查询
    SgChannelSourceStrategyRuleItemDelete: params => network.post('/api/cs/sg/SgChannelSourceStrategyRuleItem/delete', params), // 寻源规则删除行
    SgChannelSourceStrategyQuery: params => network.post('/api/cs/sg/SgChannelSourceStrategy/query', params), // 寻源策略查询详情
    exeAction: params => network.post('/p/cs/exeAction', params), // 结案
    SgChannelSourceStrategyWarehouseItemQuery: params => network.post('/api/cs/sg/SgChannelSourceStrategyWarehouseItem/query', params), // 仓优先查询列表
    SgChannelSourceStrategyWarehouseItemDel: params => network.post('/api/cs/sg/SgChannelSourceStrategyWarehouseItem/delete', params), // 仓优先查删除行


    // 共享池库存梯度策略
    sgSyncGradientStrategyShareSave: params => network.post('/api/cs/sg/SgSyncGradientStrategyShare/save', params), // 共享池库存梯度策略 - 保存
    SgSyncGradientStrategyShareQueryList: params => network.post('/api/cs/sg/SgSyncGradientStrategyShare/queryList', params), // 共享池 - 列表
    sgSyncGradientStrategyShareQueryById: params => network.post('/api/cs/sg/SgSyncGradientStrategy/queryById', params), // (配销仓/共享池) - 详情
    SgSyncGradientStrategyItemQuery: params => network.post('/api/cs/sg/SgSyncGradientStrategyItem/query', params), // (配销仓/共享池) - 右侧店铺表格详情
    SgSyncGradientStrategyCondItemDelete: params => network.post('/api/cs/sg/SgSyncGradientStrategyCondItem/delete', params), // (配销仓/共享池)  - 条件明细 - 删除
    SgSyncGradientStrategyShopItemDelete: params => network.post('/api/cs/sg/SgSyncGradientStrategyShopItem/delete', params), // (配销仓/共享池)  - 店铺明细 -删除


    // 配销仓梯度策略
    SgSyncGradientStrategySaSave: params => network.post('/api/cs/sg/SgSyncGradientStrategySa/save', params), // 配销仓梯度策略  - 保存
    SgSyncGradientStrategySaQueryList: params => network.post('/api/cs/sg/SgSyncGradientStrategySa/queryList', params), // 配销仓 - 列表




    // 渠道库存管理
    shopSelectByName: params => network.post('/api/cs/md/shop/selectByName', params),// 平台店铺查询（左侧列表）
    queryDevOpsInfoList: params => network.post('/api/cs/sg/channel/queryDevOpsInfoList', params),// 平台商品查询接口
    queryDevOpsInfo: params => network.post('/api/cs/sg/sa/queryDevOpsInfo', params),// 配销仓库
    addAllocationBill: params => network.post('/api/cs/sg/share/addAllocationBill', params),// 调入库存
    shareQueryDevOpsInfo: params => network.post('/api/cs/sg/share/queryDevOpsInfo', params),// 共享池库存列表查询
    saveDevOpsInfo: params => network.post('/api/cs/sg/channel/saveDevOpsInfo', params),// 按钮通用(停止/开启平台库存同步、是否转仓、设定安全库存)
    IncSyncStorage: params => network.post('/api/cs/sg/channel/IncSyncStorage', params),// 手动增量库存同步
    syncChannelStorage: params => network.post('/api/cs/sg/channel/syncChannelStorage', params),// 库存同步
    updateBySaStoreType: params => network.post('/api/cs/sg/channel/updateBySaStoreType', params),// 修改商品标签
    download: params => network.post('/api/cs/sg/channel/download', params),// 导出
    checkSkuStorage: params => network.post('/api/cs/sg/channel/checkSkuStorage', params),// 修改特殊条码比例
    platformInventory: params => network.post('/api/cs/sg/channel/download/platformInventory', params),// 下载平台库存
    downloadAllShopSaleStorage: params => network.post('/api/cs/sg/channel/download/allShopSaleStorage', params),//  下载全店在售库存
    storageSaleStock: params => network.post('/api/cs/sg/channel/sync/storageSaleStock', params),//  全量同步全店库存（在售）
    // 分货确认单
    confirmRejected: params => network.post('/api/cs/sg/share/allocation/confirmRejected', params),//  驳回
    // 多渠道调拨单
    queryMultiChannelTransfer: params => network.post('/api/cs/sg/queryMultiChannelTransfer', params),//  查询
    deleteMultiChannelTransfer: params => network.post('/api/cs/sg/deleteMultiChannelTransfer', params),//  删除接口
    updateMultiChannelTransfer: params => network.post('/api/cs/sg/updateMultiChannelTransfer', params),//  修改接口
    importMultiChannelTransfer: params => network.post('/api/cs/sg/importMultiChannelTransfer', params),//  导入
    exportMultiChannelTransfer: params => network.post('/api/cs/sg/exportMultiChannelTransfer', params),//  导入
    submitMultiChannelTransfer: params => network.post('/api/cs/sg/submitMultiChannelTransfer', params),//  1. 多渠道调拨单提交

    cpStoreExport: params => network.post('/api/cs/sg/SgCChannelRatioStrategy/cpStore/export', params), // 比例同步策略 - 导出

    exportSgChannelSourceStrategyForceItem: params => network.post('/api/cs/sg/exportSgChannelSourceStrategyForceItem', params),//  寻源策略定义 - 导出
    exportForceItem: params => network.post('/api/cs/sg/SgStorageSourcingStrategy/exportForceItem', params),//  寻源策略定义（新） - 导出
    getForceItemTemplateUrl: params => network.get('/api/cs/sg/SgStorageSourcingStrategy/getForceItemTemplateUrl'),//  寻源策略定义（新） - 下载模板

    queryTransferResult: params => network.post('/api/cs/sg/transfer/queryTransferResult', params),//  配销仓和聚合仓调拨完成后在单据增加详情显示所有产生对应的单据和调出方和调入方
    updateByWmsBillNo: params => network.post('/api/cs/sg/updateByWmsBillNo', params),
    sgQueryHistory: (params) => $network.post("/api/cs/sg/SgSyncGradientStrategy/history/query", params),
    deleteStore: params => network.post('/api/cs/sg/delete/deleteStore', params),
    getHistory: (params) => $network.post('/api/cs/sg/SgChannelSkuStorage/getHistory', params),
    SgStorageGetHistory: params => $network.get(`/api/cs/sg/SgStorageSourcingStrategy/getHistory?${qs.stringify(params)}`), // 寻源策略定义接口-获取历史快照详情信息
    SgStorageGetHistoryVersion: params => $network.post(`/api/cs/sg/SgStorageSourcingStrategy/getHistoryVersion`, params), // 寻源策略定义接口-查找历史版本

    getCusSourcingStrategyHistory: (params) => $network.post('/api/cs/sg/customer/find/source/history/query', params),
  };
